import { ProductAggregateDocument, ProductVariantDocument } from '@/types/manage.types';
import ProductAttributesSelector from './fragments/attributes-selector';

interface VariantSelectorProps {
  product: ProductAggregateDocument;
  onVariantChange: (variant: ProductVariantDocument | null) => void;
}

export function VariantSelector({ product, onVariantChange }: VariantSelectorProps) {
  return <ProductAttributesSelector product={product} onVariantChange={onVariantChange} />;
}
